import React, { useEffect, useState } from 'react';
import { useAppSelector } from '@/redux-config/hooks';
import { selectUser } from '@/redux-config/entities/user';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { CustomBreadCrumb } from '@/components/customBreadCrumb';
import './style.scss';
import { selectLanguage } from '@/redux-config/entities/language';
import { useTranslation } from 'react-i18next';
import { Loading } from '@/components';
import { ProductType } from '@/DTO';
import { ProductApi } from '@/api';
import { Carousel } from 'react-bootstrap';
import { ConvertNumber } from '@/utils';
import ReactHtmlParser from 'react-html-parser';
import { FileSignature } from 'lucide-react';

export const ProductInfo: React.FC<{}> = () => {
  const { id } = useParams();

  const { t } = useTranslation();

  const crumbs = [
    { name: t('Dashboard'), href: '/' },
    { name: t('Products'), href: '#' },
  ];

  const lang = useAppSelector(selectLanguage);
  const user = useAppSelector(selectUser);
  const [loading, setLoading] = useState<boolean>(true);

  const [data, setData] = useState<ProductType>();

  const handleGetData = () => {
    setLoading(true);
    ProductApi.GetProductById(user, id + '')
      .then((data) => {
        setData(data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetData();
  }, [id]);

  return (
    <>
      <Helmet>
        <title>MahdiBookShop | User info</title>
        <meta name="description" content="Basic example" />
      </Helmet>

      {loading ? (
        <Loading />
      ) : (
        <div className="d-flex flex-column">
          <div className={'d-flex flex-row justify-content-between'}>
            <CustomBreadCrumb breadCrumbList={crumbs} />
            <Link
              to={`/product/edit/${id}`}
              className={
                'btn p-1 align-baseline rounded-circle bg-custom-white border border-danger'
              }
            >
              <FileSignature />
            </Link>
          </div>
          <div className={'d-flex flex-column  rounded-3 p-2'}>
            <div className={'d-flex flex-row flex-wrap'}>
              <div className={'col-12 col-md-6 col-lg-4 p-2 '}>
                <div
                  className={'d-flex flex-column  text5-bg rounded-3 p-3 h-100'}
                >
                  <Carousel className={''}>
                    {data?.content?.map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          height={280}
                          width={140}
                          className={'d-block object-fit-contain w-100'}
                          src={item.link}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                </div>
              </div>
              <div className={'col-12 col-md-6 col-lg-4 p-2 '}>
                <div
                  className={
                    'd-flex flex-column  bg-custom-white rounded-3 p-3 h-100'
                  }
                >
                  <h5>
                    {t('title')} : {data?.title}
                  </h5>
                  <span dir={'ltr'}>
                    {' '}
                    {data?.category?.map((item, index) => (
                      <span key={index}>{item.name}/</span>
                    ))}
                  </span>
                  <span>
                    {t('publisher')} : {data?.publisher?.name}
                  </span>
                  <span>
                    {t('language')} : {data?.language}
                  </span>
                  <span>
                    {t('publish_date')} :{' '}
                    {ConvertNumber(data?.publish_date + '', lang)}
                  </span>
                  <span>
                    {t('author_name')} : {data?.author_name}
                  </span>
                  <span>
                    {t('paper_count')} :{' '}
                    {ConvertNumber(data?.paper_count + '', lang)}
                  </span>
                  <span>
                    {t('offer')} :
                    {data?.offer === 0
                      ? t('none')
                      : data?.offer === 1
                        ? t('proposal')
                        : data?.offer === 3
                          ? t('bestSell')
                          : data?.offer === 4
                            ? t('bigFirst')
                            : t('header')}
                  </span>
                  <span>
                    {t('amount')} : {ConvertNumber(data?.amount + '', lang)}
                  </span>
                  <span>
                    {t('is_auto_price')} :{' '}
                    {data?.is_auto_price ? t('active') : t('inactive')}
                  </span>
                </div>
              </div>
              <div className={'col-12 col-md-6 col-lg-4 p-2 '}>
                <div
                  className={
                    'd-flex flex-column  bg-custom-white rounded-3 p-3 h-100'
                  }
                >
                  <span>
                    {t('price')} : {ConvertNumber(data?.price + '', lang, true)}
                  </span>
                  <span>
                    {t('Size')} : {data?.pricing?.size}
                  </span>
                  <span>
                    {t('PerPrice')} : {data?.pricing?.price}
                  </span>
                  <span>
                    {t('BookingPrice')} : {data?.pricing?.bookbinding_price}
                  </span>
                  <span>
                    {t('Color')} :{' '}
                    {data?.pricing?.is_multi_color
                      ? t('multi-color')
                      : t('black-white')}
                  </span>
                </div>
              </div>
              <div className={'col-12 col-md-6 col-lg-12 p-2 '}>
                <div
                  className={
                    'd-flex flex-column  bg-custom-white rounded-3 p-3 h-100'
                  }
                >
                  <p className={'p-2'}>
                    {ReactHtmlParser(data?.description + '')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
